import React from 'react';

import { Nullable } from '@tager/web-core';

import PostView from '@/modules/Post/PostView';
import { PostFull } from '@/typings/model';

type Props = {
  post: Nullable<PostFull>;
};

const Post = ({ post }: Props) => {
  return <PostView post={post} />;
};

export default Post;
